<template>
    <el-dialog :title="title" :visible="dialogFormVisible" :before-close="handleClose" :closeOnClickModal="false">
        <el-form :label-width="labelwidth" ref="model" :model="model" :rules="rules" :label-position="labelPosition">
            <el-form-item label="中文" prop="Chinese">
                <el-input size="small" v-model="model.Chinese" auto-complete="off" placeholder="请输入中文" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="英文" prop="English">
                <el-input size="small" v-model="model.English" auto-complete="off" placeholder="请输入英文" maxlength="100"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='handleClose'>取消</el-button>
            <el-button size="small" type="primary" class="title" @click="handleSave">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {
        UpdateFieldTranslation
    } from '../../api/translate'
    export default {
        data() {
            return {
                title: '翻译编辑',
                name: 'edit',
                labelwidth: '120px',
                labelPosition: 'right',
                baseURL: window.Global.baseURL,
                model: {
                    Chinese:'',
                    English: '',
                    OID: null
                },
                rules: {
                    Chinese: [{
                        required: true,
                        message: '中文名不能为空',
                        trigger: 'blur'
                    }],
                    English: [{
                        required: true,
                        message: '英文名不能为空',
                        trigger: 'blur'
                    }],
                },
            }
        },
        props: {
            dialogFormVisible: {
                required: true,
                type: Boolean
            },
            data: {
                required: true,
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                if (this.data) {
                    this.model = this.data;
                }
            },
            handleSave() {
                this.$refs.model.validate((valid) => {
                    if (valid) {
                        this.UpdateFieldTranslation()
                    } else {
                        this.$message({
                            message: '请填写完整信息',
                            type: 'error'
                        });
                    }
                });
            },
            handleClose() {
                this.$emit('closeEditDialog')
            },
            UpdateFieldTranslation() {
                UpdateFieldTranslation(this.model).then(data => {
                    if (!data.iserror) {
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.handleClose();
                    }
                })
            },
        }
    }
</script>

<style>

</style>